import {Injectable, InjectionToken} from "@angular/core";
import {DxModalOptions} from "../domain/ui-options/dx-modal-options";


/** Конфигурация модальных окон приложения. */
@Injectable()
export class DxModalsConfig {
  public infoModalConfig?: DxModalOptions;
  public warnModalConfig?: DxModalOptions;
  public errorModalConfig?: DxModalOptions;
  public confirmModalConfig?: DxModalOptions;
  public editModalConfig?: DxModalOptions;

  constructor(config: Partial<DxModalsConfig>) {
    this.infoModalConfig = config.infoModalConfig;
    this.warnModalConfig = config.warnModalConfig;
    this.errorModalConfig = config.errorModalConfig;
    this.confirmModalConfig = config.confirmModalConfig;
    this.editModalConfig = config.editModalConfig;
  }
}

export const DX_MODALS_CONFIG = new InjectionToken<DxModalsConfig>('DX_MODALS_CONFIG');
